import React from "react";
import Validator from "validator";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { FormGroup, Alert, Button } from "react-bootstrap";
import NProgress from "nprogress";
import InlineError from "../../messages/InlineError";
import UserService from "../../../services/UserService";
import { mapDispatchToProps } from "../../../RootReducer";
import { loginAction } from "../../../actions/UserActions";
import LoaderInline from "../../helpers/LoaderInline";

class LoginForm extends React.Component {

	state = {
		data: {
			email: "",
			password: ""
		},
		loading: false,
		errors: {}
	};

	onChange = (e) => {
		this.setState({
			data: { ...this.state.data, [e.target.name]: e.target.value }
		});
	};

	onSubmit = (e) => {
		e.preventDefault();
		NProgress.start();
		const errors = this.validate(this.state.data);
		this.setState({ errors });
		if (Object.keys(errors).length === 0) {
			this.setState({ loading: true });
			this.userService.login(this.state.data)
				.then((response) => {
					this.userService.setLoggedInUser(response.data);
					this.props.dispatch(loginAction(response.data));
					NProgress.done();
				}).catch((error) => {
				 
					this.setState({ loading: false, errors: { email: " ", password: " ", "message": "Incorrect credential!" } });
				});
		} else {
			NProgress.done();
		}
	};

	userService = new UserService(this);

	validate = (data) => {
		const errors = {};
		if (!Validator.isEmail(data.email)) { errors.email = "Invalid email"; }
		if (!data.password) { errors.password = "Can't be blank password"; }
		return errors;
	};

	render() {
		const { data, errors, loading } = this.state;
		return (
			<div className="form-wrapper">
				<h2 className="text-center">Sign in</h2>

				<form onSubmit={this.onSubmit}>
					<FormGroup validationState={errors.email && "error"}>
						<div className="input-group">
							<input
								type="email"
								className="form-control"
								id="username"
								placeholder="Email"
								name="email"
								value={data.email}
								onChange={this.onChange}
							/>
							<div className="input-group-addon">
								<i className="material-icons">mail_outline</i>
							</div>
						</div>
						{errors.email && <InlineError text={errors.email} />}
					</FormGroup>
					<FormGroup validationState={errors.password && "error"}>
						<div className="input-group">
							<input
								type="password"
								name="password"
								className="form-control"
								id="password"
								placeholder="Password"
								value={data.password}
								onChange={this.onChange}
							/>
							<div className="input-group-addon">
								<i className="material-icons">lock_outline</i>
							</div>
						</div>
						{errors.password && <InlineError text={errors.password} />}
					</FormGroup>
					{errors.message && <span className="text-danger alert-message">{errors.message}</span>}
					<div className="row">
						<div className="col-sm-12">
							<Button bsStyle="primary" className="pull-right btn-login" disabled={loading} type="submit">
								{loading ? <LoaderInline width="20" height="20" color="#fff"/> : "Sign in"}
							</Button>
						</div>
					</div>
				</form>
				
				<div className="footer-links">
					<Link to="/forgot-password" className="btn-block btn-link">I forgot my password </Link>
				</div>
				<div className="clearfix" />
			</div>
		);
	}
}
LoginForm.propTypes = {
	// match: PropTypes.shape({
	// 	params: PropTypes.shape().isRequired,
	// }).isRequired,
	 dispatch: PropTypes.func.isRequired,
	// history: PropTypes.shape({
	// 	push: PropTypes.func
	// }).isRequired
};
export default connect(mapDispatchToProps)(withRouter(LoginForm));


// WEBPACK FOOTER //
// ./src/components/forms/public-pages/LoginForm.js